import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";

export default function TiltCard({ project, index = 0 }) {
  const wrapRef = useRef(null);
  const innerRef = useRef(null);
  const imgRef = useRef(null);

  const onMove = (e) => {
    const el = wrapRef.current;
    if (!el || !innerRef.current) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    innerRef.current.style.transform = `perspective(1200px) rotateX(${-y * 7}deg) rotateY(${x * 9}deg)`;
    if (imgRef.current) {
      imgRef.current.style.transform = `translate3d(${x * -18}px, ${y * -18}px, 0) scale(1.08)`;
    }
  };

  const onLeave = () => {
    if (innerRef.current) {
      innerRef.current.style.transform = "perspective(1200px) rotateX(0deg) rotateY(0deg)";
    }
    if (imgRef.current) {
      imgRef.current.style.transform = "translate3d(0,0,0) scale(1)";
    }
  };

  const idLabel = project.sort_order
    ? `P-${String(project.sort_order).padStart(3, "0")}`
    : `P-${String(index + 1).padStart(3, "0")}`;

  return (
    <div
      ref={wrapRef}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className="relative aspect-[16/10] [transform-style:preserve-3d]"
      data-cursor-hover
      data-testid={`tilt-card-${project.id}`}
    >
      <div
        ref={innerRef}
        className="absolute inset-0 transition-transform duration-300 ease-out border border-white/[0.06] overflow-hidden"
        style={{ transformStyle: "preserve-3d" }}
      >
        <img
          ref={imgRef}
          src={project.image_url}
          alt={project.title}
          width="800"
          height="500"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover grayscale-[0.3] transition-transform duration-500 ease-out"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute top-4 left-4 right-4 flex items-center justify-between font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/70">
          <span>{idLabel}</span>
          <span>{project.year}</span>
        </div>
        <div className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-[#29ABE2] text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight size={16} />
        </div>
      </div>
    </div>
  );
}
